import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';
import { ModalController, AlertController, LoadingController } from '@ionic/angular/lazy';
import { ObserverService } from 'src/app/services/observer.service';
import { ParkedCartService } from 'src/app/services/parked-cart.service';

@Component({
    selector: 'app-parked-cart-edit',
    templateUrl: './parked-cart-edit.page.html',
    styleUrls: ['./parked-cart-edit.page.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ParkedCartEditPage implements OnInit {

    online = true;
    spinner = null;
    loading_spinner = null;
    loading = false;
    @Input() parked_cart_id = null;
    parked_cart = null;
    params = {}

    constructor(
        public modalController: ModalController,
        public alertController: AlertController,
        private observerService: ObserverService,
        public loadingController: LoadingController,
        private parkedCartService: ParkedCartService,
    ) { }

    ngOnInit() {

        if (this.parked_cart_id) {


            this.loadData().then(() => {

                this.params['cart'] = this.parked_cart.cart;

                if(this.parked_cart.label) {
                    this.params['label'] = this.parked_cart.label;
                }

            })
            .catch(() => { });

        }

        this.observerService.subscribe('network_status_changed|parked_cart_edit_modal', (network_status) => {
            if(network_status) {
                this.online = network_status.connected;
                if(this.online) {
                    this.loadData().then(() => {} ).catch(() => { });
                }
                else {
                    this.presentAlert("Offline", "You must be online to edit a parked cart, please check your network connection and try again.");
                }
            }
        });

    }

    ngOnDestroy() {
        this.observerService.destroy("network_status_changed|parked_cart_edit_modal");
    }

    loadData() {
        return new Promise<void>((resolve, reject) => {
            this.presentLoadingSpinner("Loading parked cart").then(() => {
                this.loadParkedCart().then(() => {
                    this.loading_spinner.dismiss();
                    resolve();
                })
                .catch(() => {
                    this.loading_spinner.dismiss();
                    reject();
                });
            });
        });
    }

    loadParkedCart() {
        return new Promise<void>((resolve, reject) => {
            this.parked_cart = null;
            this.parkedCartService.getParkedCart(this.parked_cart_id).then((parked_cart) => {
                if(parked_cart) {
                    this.parked_cart = parked_cart;
                }
                resolve();
            })
            .catch(() => {
                reject();
            });
        });
    }

    close() {
        this.modalController.dismiss();
    }

    update() {
        this.presentSpinner("Updating parked cart").then(() => {

            if(this.params['label'] == null || this.params['label'].trim() === "") {
                this.params['label'] = "";
            } 

            this.parkedCartService.updateParkedCart(this.parked_cart_id, this.params).then(() => {
                this.spinner.dismiss();
                this.modalController.dismiss();
            })
            .catch(() => {
                this.spinner.dismiss();
            })

        })
    }

    async presentAlert(header, message) {
        const alert = await this.alertController.create({
            header: header,
            message: message,
            buttons: ['OK']
        });
        await alert.present();
    }

    async presentSpinner(message) {
        this.spinner = await this.loadingController.create({
            message: message,
            showBackdrop: false,
            cssClass: 'loading-spinner'
        });
        await this.spinner.present();
    }

    async presentLoadingSpinner(message) {
        this.loading = true;
        this.loading_spinner = await this.loadingController.create({
            message: message,
            showBackdrop: false,
            cssClass: 'loading-spinner'
        });
        this.loading_spinner.onDidDismiss().then(() => {
            this.loading = false;
        });
        await this.loading_spinner.present();
    }

}
